import { SVGComponentProps } from "./utils/Types"

const ExpiryIcon = ({ width = 16, height = 8, className }: SVGComponentProps) => {
    return (
        <svg
            className={`text-current ${className}`}
            width={width}
            height={height}
            viewBox="0 0 16 8"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 6.5C9.38071 6.5 10.5 5.38071 10.5 4C10.5 2.61929 9.38071 1.5 8 1.5C6.61929 1.5 5.5 2.61929 5.5 4C5.5 5.38071 6.61929 6.5 8 6.5ZM8 8C9.95279 8 11.5787 6.6006 11.9298 4.75H15.25H16V3.25H15.25H11.9298C11.5787 1.39935 9.95279 0 8 0C6.04721 0 4.42125 1.39935 4.0702 3.25H0.75H0V4.75H0.75H4.0702C4.42125 6.6006 6.04721 8 8 8Z"
                fill="currentColor" />
        </svg>
    )
}

export default ExpiryIcon
